module.exports = __webpack_public_path__ + "website/img/serveImg05.9566a2ae.png";